import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { StaffDatabase } from './staff-database';
import { ProfessionalConceptDto } from '../../../../../models/professional-concept/professional-concept-dto';


/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, StoreDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class StaffDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    _shiftId = -1;
    filteredData: ProfessionalConceptDto[] = [];
    renderedData: ProfessionalConceptDto[] = [];
    dataLength = 0;

    constructor(
        private _staffDatabase: StaffDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort,
        private _shiftSelected
    ) {
        super();
        this._shiftId = _shiftSelected;
        // Reset to the first page when the store changes the filter.
        // this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    filterEmployee(divisionId){
        this._shiftId = divisionId;
        this._filterChange.next(this.filter);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<ProfessionalConceptDto[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._staffDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._staffDatabase.data.slice().filter((item: ProfessionalConceptDto) => {
                const searchStr = (item.FullName).toLowerCase();
                return (searchStr.indexOf(this.filter.toLowerCase()) !== -1 && (this._shiftId === -1 || item.Shifts.find(e => e.ShiftId === this._shiftId)));
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            // const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData; // .splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._staffDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: ProfessionalConceptDto[]): ProfessionalConceptDto[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'LastName':
                    [propertyA, propertyB] = [a.FullName, b.FullName];
                    break;
                // case '':
                //     [propertyA, propertyB] = [a.description, b.description];
                //     break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/professional-concept/edit-professional-concept/staff-data-source.ts